class PasswordInputToggle extends HTMLElement {
  constructor() {
    super();
    const input = this.querySelector('[data-password-input]');
    const toggleButton = this.querySelector('[data-toggle-button]');

    toggleButton.addEventListener('click', () => {
      const isPassword = input.getAttribute('type') === 'password';
      input.setAttribute('type', isPassword ? 'text' : 'password');
      toggleButton.classList.toggle('[&_.password-hide]:block');
      toggleButton.classList.toggle('[&_.password-show]:hidden');
      toggleButton.classList.toggle('[&_.password-hide]:hidden');
      toggleButton.classList.toggle('[&_.password-show]:block');
    });
  }
}

customElements.define('password-input-toggle', PasswordInputToggle);
